import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_EXPORT_ACTION,
  CSV_IMPORT_ACTION,
  ITableAction,
  TableControlComponent,
  TableControlModule,
} from 'frontier/browserkit';
import AppControlGuids from '../../../api/ControlGuids';

@Component({
  selector: 'app-payer-hidden-table',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
  providers: [{provide: TableControlComponent, useExisting: PayerHiddenTableComponent}],
})
export class PayerHiddenTableComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TPayerTableView;
  override tableName: string = 'Kostenträger';
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    CSV_EXPORT_ACTION,
    CSV_IMPORT_ACTION,
  ]);
}
